var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgFlashcardWhite = props => /*#__PURE__*/React.createElement("svg", _extends({
  width: 20,
  height: 20,
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M10.174 1.101a1.39 1.39 0 0 0-1.286 1.09c-.846 3.817-1.078 6.389-.91 10.294a1.391 1.391 0 0 0 1.068 1.296c2.907.685 4.92.866 7.899.701a1.392 1.392 0 0 0 1.284-1.11c.784-3.787 1.01-6.337.906-10.245A1.396 1.396 0 0 0 18.048 1.8c-2.894-.65-4.904-.846-7.874-.699Zm-4.203 4.24a.355.355 0 0 1 .46.39c-.288 2.18-.349 4.232-.237 6.83a3.177 3.177 0 0 0 2.442 2.958c1.792.422 3.282.665 4.838.76.096.005.131.12.046.166-2.626 1.413-4.527 2.105-7.45 2.718a1.391 1.391 0 0 1-1.516-.72c-1.81-3.464-2.692-5.892-3.546-9.706a1.39 1.39 0 0 1 .702-1.533c1.555-.826 2.857-1.4 4.261-1.863Z",
  fill: "#FFF"
})));
export default SvgFlashcardWhite;